import clsx from "clsx";
import SidebarRouter from "router/SidebarRouter";
import { useAppSelector } from "state/hooks";
import SidebarCollapse from "./sidebarCollapse";
import SidebarLogo from "./sidebarLogo";

const Sidebar = () => {
  const { collapsedSidebar } = useAppSelector((state) => state.theme);

  return (
    <div
      className={clsx("app-dashboard-sidebar", {
        show: collapsedSidebar,
      })}
    >
      <div className="app-dashboard-sidebar-menu">
        <SidebarLogo />
        <SidebarRouter />
        <SidebarCollapse />
      </div>
    </div>
  );
};

export default Sidebar;
